<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="模版名称"><el-input v-model="queryParams.title" placeholder="请输入模版名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleDetail" v-has="'btn_add'">添加</el-button>
						<el-button type="danger" size="small" @click="batchDelete" v-has="'btn_del'">批量删除</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column fixed type="selection" width="55" v-if="showSelection"></el-table-column>
					<el-table-column prop="title" label="模版名称"></el-table-column>
					<el-table-column prop="variableCount" label="变量总数"></el-table-column>
					<el-table-column prop="institutionName" label="所属组织"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope" ref="buttons">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
							<el-button size="mini" type="primary" @click="handleCopy(scope.row)" v-has="'btn_copy'">复制</el-button>
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import common from '@/common/common.js';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'template',
				name: '模版',
				rules: {
					title: [{
							required: true,
							message: '请输入模版名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					variableCount: [{
							required: true,
							message: '请输入变量数量',
							trigger: 'blur'
						},
						{
							max: 10,
							message: '长度最长支持10',
							trigger: 'blur'
						}
					],
					collectType: [{
							required: true,
							message: '请输入采集方式',
							trigger: 'blur'
						},
						{
							max: 10,
							message: '长度最长支持10',
							trigger: 'blur'
						}
					],
				},
			};
		},
		filters: {},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			handleDetail(row) {
				if (row) {
					common.routerPush(this, '/front/device/templateVariable', {
							templateId: row.id
					})
				} else {
					common.routerPush(this, '/front/device/templateVariable')
				}
			}
		},
		mounted: function() {}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/template.vue